export const WORK_HOURS_PER_WEEK = 40;
export const ADMIN_HOURS = 4;

/**
 * Compute utilization metrics for one person for one week.
 * Denominator is always the fixed 40-hour week.
 * Available capacity deducts the flat 4-hr admin allocation, PTO, hard-scheduled, and soft-scheduled hours.
 */
export function computePersonUtilization({
  scheduledHours = 0,
  softScheduledHours = 0,
  actualHours = 0,
  ptoHours = 0,
} = {}) {
  const safe = (v) => (Number.isFinite(v) && v >= 0 ? v : 0);
  const sched = safe(scheduledHours);
  const soft = safe(softScheduledHours);
  const actual = safe(actualHours);
  const pto = safe(ptoHours);

  return {
    scheduledHours: sched,
    softScheduledHours: soft,
    actualHours: actual,
    ptoHours: pto,
    availableCapacity: Math.max(0, WORK_HOURS_PER_WEEK - ADMIN_HOURS - pto - sched - soft),
    scheduledUtilization: sched / WORK_HOURS_PER_WEEK,
    softScheduledUtilization: soft / WORK_HOURS_PER_WEEK,
    actualUtilization: actual / WORK_HOURS_PER_WEEK,
  };
}
